import { CURRENT_USER, post, SET_MFA_SETTING } from '@services';

const SANDBOX_HOSTNAME = 'authentik8.sandbox.aws.valeur.io';

export const isMfaSettingEnvironment = (): boolean => {
  const hostname = window.location.hostname;

  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === SANDBOX_HOSTNAME
  );
};

export const getMfaErrorMessage = (error: unknown): string => {
  const apiError = (error as {
    response?: { data?: { error?: { code?: string; message?: string } } };
  })?.response?.data?.error;

  return (
    apiError?.message ||
    apiError?.code ||
    'Unable to update MFA setting. Please try again.'
  );
};

export const fetchMfaEnabled = async (): Promise<boolean | null> => {
  const response = await post(CURRENT_USER, {}, false);

  if (typeof response?.user?.isMfaEnabled === 'boolean') {
    return response.user.isMfaEnabled;
  }

  return null;
};

export const updateMfaSetting = async (isEnabled: boolean): Promise<void> => {
  if (!isMfaSettingEnvironment()) {
    throw new Error(
      'MFA settings are only available in local and sandbox environments.'
    );
  }

  await post(SET_MFA_SETTING, { isEnabled }, false);
};

export const getMfaSuccessMessage = (isEnabled: boolean): string =>
  isEnabled
    ? 'Multi-factor authentication has been enabled.'
    : 'Multi-factor authentication has been disabled.';

export const parseMfaEnabledParam = (
  value: string | null
): boolean | null => {
  if (value === 'true') {
    return true;
  }

  if (value === 'false') {
    return false;
  }

  return null;
};
